import { useMemo } from 'react';
import { ConsentsAndDeclarationsType } from '../../../api/types';
import { hasValue } from '../../../utilities/fp';
import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

const useConsentsAndDeclarationsValidator = (isUpdate = false) => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.only(() => !isUpdate, validators.requiredString('moduleId')),
                validators.only(
                    () => !isUpdate,
                    validators.requiredStringEnum('consentType', ConsentsAndDeclarationsType)
                ),

                validators.only(
                    values => !hasValue('description.defaultValue')(values) || values.description.defaultValue === '',
                    validators.requiredString('title.defaultValue')
                ),
                validators.only(
                    values => !hasValue('title.defaultValue')(values) || values.title.defaultValue === '',
                    validators.requiredString('description.defaultValue')
                ),

                validators.requiredString('displayName'),
                validators.requiredNumber('orderNumber'),
                validators.requiredArray('purpose')
            ),
        [isUpdate]
    );

    return useValidator(validator);
};

export default useConsentsAndDeclarationsValidator;
